"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  dataToItem: true,
  deltaToExpression: true,
  itemToData: true
};
exports.itemToData = exports.deltaToExpression = exports.dataToItem = void 0;

var _now = require("./functions/now");

var _booleanItemValue = require("./guards/boolean-item-value");

var _dataArray = require("./guards/data-array");

var _dataObject = require("./guards/data-object");

var _listItemValue = require("./guards/list-item-value");

var _mapItemValue = require("./guards/map-item-value");

var _nullItemValue = require("./guards/null-item-value");

var _numberItemValue = require("./guards/number-item-value");

var _stringItemValue = require("./guards/string-item-value");

var _reservedWords = require("./reserved-words");

var _index = require("./interfaces/index");

Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _index[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index[key];
    }
  });
});

var _index2 = require("./types/index");

Object.keys(_index2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _index2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _index2[key];
    }
  });
});
/*
 * @todo Explicitly referencing the barrel file seems to be necessary when enabling the
 * isolatedModules compiler option.
 */
// @todo This can be replaced with Object.fromEntries() once the support for Node v10 is dropped.

var fromEntries = function fromEntries(entries) {
  return Array.from(entries).reduce(function (object, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        property = _ref2[0],
        value = _ref2[1];

    return _objectSpread(_objectSpread({}, object), {}, _defineProperty({}, property, value));
  }, {});
};

var convertDataValue = function convertDataValue(value) {
  if (value === null) {
    return {
      NULL: true
    };
  }

  if (typeof value === 'boolean') {
    return {
      BOOL: value
    };
  }

  if (typeof value === 'number') {
    return {
      N: value.toString()
    };
  }

  if (typeof value === 'string') {
    return {
      S: value
    };
  }

  if ((0, _dataArray.isDataArray)(value)) {
    return {
      L: convertDataArray(value)
    };
  }

  if ((0, _dataObject.isDataObject)(value)) {
    return {
      M: convertDataObject(value)
    };
  }

  throw new Error('Unsupported data type');
};

var convertDataArray = function convertDataArray(array) {
  return array.map(function (value) {
    return convertDataValue(value);
  });
};

var convertDataObject = function convertDataObject(object) {
  var entries = Object.entries(object).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        value = _ref4[1];

    return value !== undefined;
  }).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return [key, convertDataValue(value)];
  });
  return fromEntries(entries);
};

var isReservedWord = function isReservedWord(property) {
  return _reservedWords.RESERVED_WORDS.some(function (reservedWord) {
    return reservedWord === property.toUpperCase();
  });
};

var illegalWordRegex = /[\s|.]/g;

var isIllegalWord = function isIllegalWord(property) {
  return illegalWordRegex.test(property) || isReservedWord(property);
};

var createPropertyName = function createPropertyName(property, expressionAttributeNames) {
  var propertyName = property.replace(illegalWordRegex, '');
  var expressionAttributeName = "#".concat(propertyName);

  while (expressionAttributeName in expressionAttributeNames) {
    propertyName = "".concat(propertyName, "_");
    expressionAttributeName = "#".concat(propertyName);
  }

  expressionAttributeNames["#".concat(propertyName)] = property;
  return propertyName;
};

var formRemoveStatement = function formRemoveStatement(property, expressionAttributeNames) {
  if (isIllegalWord(property)) {
    var propertyName = createPropertyName(property, expressionAttributeNames);
    return "#".concat(propertyName);
  }

  return property;
};

var formSetStatement = function formSetStatement(property, value, expressionAttributeNames, expressionAttributeValues) {
  if (isIllegalWord(property)) {
    var propertyName = createPropertyName(property, expressionAttributeNames);
    expressionAttributeValues[":".concat(propertyName)] = convertDataValue(value);
    return "#".concat(propertyName, " = :").concat(propertyName);
  }

  expressionAttributeValues[":".concat(property)] = convertDataValue(value);
  return "".concat(property, " = :").concat(property);
};

var convertItemValue = function convertItemValue(value) {
  if ((0, _booleanItemValue.isBooleanItemValue)(value)) {
    return value.BOOL;
  }

  if ((0, _listItemValue.isListItemValue)(value)) {
    return convertItemArray(value.L);
  }

  if ((0, _mapItemValue.isMapItemValue)(value)) {
    return convertItemObject(value.M);
  }

  if ((0, _numberItemValue.isNumberItemValue)(value)) {
    if (/\./.test(value.N)) {
      return parseFloat(value.N);
    }

    return parseInt(value.N, 10);
  }

  if ((0, _nullItemValue.isNullItemValue)(value)) {
    return null;
  }

  if ((0, _stringItemValue.isStringItemValue)(value)) {
    return value.S;
  }

  throw new Error('Unsupported data type');
};

var convertItemArray = function convertItemArray(array) {
  return array.map(function (value) {
    return convertItemValue(value);
  });
};

var convertItemObject = function convertItemObject(object) {
  var entries = Object.entries(object).filter(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        value = _ref8[1];

    return value !== undefined;
  }).map(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        key = _ref10[0],
        value = _ref10[1];

    return [key, convertItemValue(value)];
  });
  return fromEntries(entries);
};

var dataToItem = function dataToItem(data) {
  var created = (0, _now.now)();
  return convertDataObject(_objectSpread(_objectSpread({}, data), {}, {
    created: created,
    modified: created
  }));
};

exports.dataToItem = dataToItem;

var deltaToExpression = function deltaToExpression(delta) {
  var expressionAttributeNames = {};
  var modified = (0, _now.now)();
  var expressionAttributeValues = {
    ':modified': {
      N: modified.toString()
    }
  };
  var removeStatements = [];
  var setStatements = ['modified = :modified'];
  var updateExpressions = [];

  for (var _i = 0, _Object$entries = Object.entries(delta); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        property = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value === undefined) {
      removeStatements.push(formRemoveStatement(property, expressionAttributeNames));
    } else if (typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string' || typeof value === 'object') {
      setStatements.push(formSetStatement(property, value, expressionAttributeNames, expressionAttributeValues));
    }
  }

  if (removeStatements.length > 0) {
    updateExpressions.push("REMOVE ".concat(removeStatements.join(', ')));
  }

  if (setStatements.length > 0) {
    updateExpressions.push("SET ".concat(setStatements.join(', ')));
  }

  return {
    expressionAttributeNames: Object.keys(expressionAttributeNames).length > 0 ? expressionAttributeNames : undefined,
    expressionAttributeValues: expressionAttributeValues,
    updateExpression: updateExpressions.join(' ')
  };
};

exports.deltaToExpression = deltaToExpression;

var itemToData = function itemToData(item) {
  return convertItemObject(item);
};

exports.itemToData = itemToData;